import { jsx as _jsx } from "react/jsx-runtime";
import { AttributeDataType } from "@plansoft-configuration-renderer/configuration-api";
import { useCsAttribute } from "@plansoft-configuration-renderer/framework";
import { EditNotSupported } from "./Edit.NotSupported";
import { NumericEdit } from "./Edit.NumericEdit";
import { TextEdit } from "./Edit.TextEdit";
export function Edit(_props) {
    const attribute = useCsAttribute();
    const isNumeric = attribute.dataType === AttributeDataType.Integer ||
        attribute.dataType === AttributeDataType.Double;
    if (isNumeric) {
        return _jsx(NumericEdit, {});
    }
    if (attribute.dataType === AttributeDataType.String) {
        return _jsx(TextEdit, {});
    }
    // non supported edit type
    return _jsx(EditNotSupported, {});
}
//# sourceMappingURL=Edit.js.map